import { GenericCallCard, GenericEventCard } from './chunk-75AWSO74.js';

// src/protocols/dydx/index.ts
var DYDX_HINTS = {
  "valueHints": [],
  "callHints": [
    { "protocolId": "dydx_clob", "call": "place_order", "label": "dYdX order submission", "component": "DydxCall", "summaryFields": ["dydx_clob"] },
    { "protocolId": "dydx_clob", "call": "cancel_order", "label": "dYdX order cancellation request", "component": "DydxCall", "summaryFields": ["dydx_clob"] },
    { "protocolId": "dydx_clob", "call": "batch_cancel", "label": "dYdX batch cancellation request", "component": "DydxCall", "summaryFields": ["dydx_clob"] },
    { "protocolId": "dydx_clob", "call": "update_leverage", "label": "dYdX leverage update submission", "component": "DydxCall", "summaryFields": ["dydx_clob"] },
    { "protocolId": "dydx_sending", "call": "deposit_to_subaccount", "label": "dYdX subaccount deposit", "component": "DydxCall", "summaryFields": ["dydx_sending"] },
    { "protocolId": "dydx_sending", "call": "withdraw_from_subaccount", "label": "dYdX subaccount withdrawal", "component": "DydxCall", "summaryFields": ["dydx_sending"] },
    { "protocolId": "dydx_sending", "call": "subaccount_transfer", "label": "dYdX subaccount transfer", "component": "DydxCall", "summaryFields": ["dydx_sending"] },
    {
      "protocolId": "dydx",
      "call": "operate",
      "label": "dYdX Solo account operations",
      "summaryFields": [
        "accounts",
        "actions"
      ],
      "component": "DydxCall"
    },
    {
      "protocolId": "dydx",
      "call": "callFunction",
      "label": "dYdX Solo account callback",
      "summaryFields": [
        "sender",
        "accountInfo"
      ],
      "component": "DydxCall"
    },
    {
      "protocolId": "dydx",
      "call": "updateState",
      "label": "dYdX StarkEx state update submission",
      "summaryFields": [],
      "component": "DydxCall"
    }
  ],
  "eventHints": [
    {
      "protocolId": "dydx",
      "event": "LogOperation",
      "label": "dYdX Solo operation",
      "summaryFields": [
        "sender"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogDeposit",
      "label": "dYdX deposit",
      "summaryFields": [
        "accountOwner",
        "accountNumber",
        "market",
        "update",
        "depositorEthKey",
        "starkKey",
        "vaultId",
        "assetType",
        "quantizedAmount",
        "nonQuantizedAmount"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogWithdraw",
      "label": "dYdX Solo withdrawal",
      "summaryFields": [
        "accountOwner",
        "accountNumber",
        "market",
        "update",
        "to"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogCall",
      "label": "dYdX Solo callback",
      "summaryFields": [
        "accountOwner",
        "accountNumber",
        "callee"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogTransfer",
      "label": "dYdX Solo account transfer",
      "summaryFields": [
        "accountOneOwner",
        "accountOneNumber",
        "accountTwoOwner",
        "accountTwoNumber",
        "market",
        "updateOne",
        "updateTwo"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogIndexUpdate",
      "label": "dYdX Solo interest index",
      "summaryFields": [
        "market",
        "index"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogWithdrawalAllowed",
      "label": "dYdX StarkEx withdrawal authorized",
      "summaryFields": [
        "starkKey",
        "assetType",
        "quantizedAmount",
        "nonQuantizedAmount"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogWithdrawalPerformed",
      "label": "dYdX StarkEx withdrawal performed",
      "summaryFields": [
        "recipient",
        "starkKey",
        "assetType",
        "quantizedAmount",
        "nonQuantizedAmount"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogForcedWithdrawalRequest",
      "label": "dYdX StarkEx forced withdrawal requested",
      "summaryFields": [
        "starkKey",
        "vaultId",
        "quantizedAmount"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogDepositCancel",
      "label": "dYdX StarkEx deposit cancellation requested",
      "summaryFields": [
        "starkKey",
        "vaultId",
        "assetId"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogDepositCancelReclaimed",
      "label": "dYdX StarkEx cancelled deposit reclaimed",
      "summaryFields": [
        "starkKey",
        "vaultId",
        "assetType",
        "quantizedAmount",
        "nonQuantizedAmount"
      ],
      "component": "DydxEvent"
    },
    {
      "protocolId": "dydx",
      "event": "LogUpdateState",
      "label": "dYdX StarkEx state update",
      "summaryFields": [
        "sequenceNumber",
        "batchId"
      ],
      "component": "DydxEvent"
    }
  ]
};
function registerDydx(registry) {
  registry.registerCall("DydxCall", GenericCallCard);
  registry.registerEvent("DydxEvent", GenericEventCard);
  registry.registerHints(DYDX_HINTS);
  return registry;
}

export { DYDX_HINTS, registerDydx };
//# sourceMappingURL=chunk-FLTIX65J.js.map
//# sourceMappingURL=chunk-FLTIX65J.js.map